import { defineElement, html } from '@webtides/element-js';
import BaseRadioField from '../../../../legacy-library/webcomponents/_form/radio-field/radio-field.class';
import style from './radio-field.css';
import { unsafeHTML } from 'lit-html/directives/unsafe-html';

export default class RadioField extends BaseRadioField {
    constructor() {
        super({ styles: [style] });
    }

    properties() {
        return {
            ...super.properties(),
            image: null,
        };
    }

    selectedIndicatorTemplate() {
        return html` <svg-icon name="check" class="checked w-full h-full"></svg-icon> `;
    }

    labelTemplate() {
        return html``;
    }

    imageTemplate() {
        if (!this.image) return '';

        return html`<div class="image">${unsafeHTML(this.image)}</div>`;
    }

    fieldTemplate() {
        return html`
            <label for="input-${this.uuid}">
                <input
                    ref="input"
                    type="radio"
                    id="input-${this.uuid}"
                    aria-describedby="${this.uuid}-help"
                    value="${this.value}"
                    name="${this.name}"
                    ?disabled="${this.disabled}"
                    ?checked="${this.checked}"
                    ?required="${this.required}"
                />
                <div class="checked-indicator">
                    <div class="checked"></div>
                </div>
                ${this.imageTemplate()}
                <div class="label">${this.label}</div>
            </label>
        `;
    }
}

defineElement('radio-field', RadioField);
